import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import NotificationByStaffModal from '../../NotificationByStaffModal/NotificationByStaffModal.vue';
import NotificationStaffTotalModal from '../../NotificationStaffTotalModal/NotificationStaffTotalModal.vue';
import {notificationSubscriberList,notificationStatusListBySubscriber} from '@/types/Component';


@Component({
    components: {
        NotificationByStaffModal,
        NotificationStaffTotalModal
      }
})
   
export default class NotificationStatusBySubscriberDetails extends Vue {

  isShowNotificationBystaffModal =false
  isShowNotificationTotalStaffModal =false
  selectedNotificaitionId=""
  subscriberDetails : any = []
  sortByPublishDateIsAsc= false
  sortByReadCountAsc = false
  sortByUnrReadCountAsc = false
  sortByNotificationTitleASC= false
 
  @Prop({ default: null })
  private notificationId!: string;

  @Prop({ default: null })
  private subscriptionId!: string;

  @Prop({ default: null })
  private notificationStatusListBySubscriber!: notificationStatusListBySubscriber[];

  @Prop({ default: null })
  private notificationSubscriberList!: notificationSubscriberList[];

  @Prop()
  isNotificationSubscriberModal!: boolean 

  get notificationSubscribeModalOpen():boolean{
    return(
       this.isShowNotificationBystaffModal ||
       this.isShowNotificationTotalStaffModal
    )
  }

  @Watch('isShowNotificationBystaffModal')
  openNotificationByStaffModal(){
    if(this.isShowNotificationBystaffModal === false){
       this.$emit('update:isNotificationSubscriberModal', false);
    }
  }

  @Watch('isShowNotificationTotalStaffModal')
  openNotificationStaffTotalModal(){
    if(this.isShowNotificationTotalStaffModal === false){
       this.$emit('update:isNotificationSubscriberModal', false);
    }
  }

  @Watch('notificationSubscribeModalOpen')
  openNotificationPopupModal(val:boolean){
    this.$root.$emit('header-inert', val);
  }
 
@Watch("subscriptionId")
setSubscriberDetails(){
  this.subscriberDetails= this.notificationSubscriberList.find((item :any)=>{
    return this.subscriptionId == item.tenantId
  })
}

sortByPublishDate(isSwitchAsc?: boolean) {
  this.sortByPublishDateIsAsc = isSwitchAsc ? !this.sortByPublishDateIsAsc : this.sortByPublishDateIsAsc;
  this.notificationStatusListBySubscriber.sort((a: any, b: any) => {
    const dateA = Date.parse(a.publishDate);
    const dateB = Date.parse(b.publishDate);
    return this.sortByPublishDateIsAsc ? dateA - dateB : dateB - dateA;
  });
}

sortByReadCount(isSwitchAsc?: boolean) {
  this.sortByReadCountAsc = isSwitchAsc ? !this.sortByReadCountAsc : this.sortByReadCountAsc;
  this.notificationStatusListBySubscriber.sort((a: any, b: any) => {
    const countA = a.notificationReadCount || 0;
    const countB = b.notificationReadCount || 0; 

    return this.sortByReadCountAsc ? countA - countB : countB - countA;
  });
}

sortByUnReadCount(isSwitchAsc?: boolean) {
  this.sortByReadCountAsc = isSwitchAsc ? !this.sortByReadCountAsc : this.sortByReadCountAsc;
  this.notificationStatusListBySubscriber.sort((a: any, b: any) => {
    const countA = a.notificationUnreadCount || 0;
    const countB = b.notificationUnreadCount || 0; 
    return this.sortByReadCountAsc ? countA - countB : countB - countA;
  });
}

staffTotalOpenModal(){
   this.isShowNotificationTotalStaffModal =true;
   this.$emit('update:isNotificationSubscriberModal', true);
}


sortByNotificationTitle(isSwitchAsc?: boolean) {
  this.sortByNotificationTitleASC = isSwitchAsc ? !this.sortByNotificationTitleASC : this.sortByNotificationTitleASC
  this.notificationStatusListBySubscriber.sort((a :any, b:any) => {
      const valueA = a.notificationTitle;
      const valueB = b.notificationTitle;
      return this.sortByNotificationTitleASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
  })
}

  openModal(notificationId:string){
      this.isShowNotificationBystaffModal =true;
      this.$emit('update:isNotificationSubscriberModal', true);
      this.selectedNotificaitionId =notificationId;
  }

  private dateFormat(date: Date) {
    if(date){
      const year = new Date(date).getFullYear();
      const month = ("0" + (new Date(date).getMonth() + 1)).slice(-2);
      const day = ("0" + new Date(date).getDate()).slice(-2);
      return year + '/' + month + '/' + day;
    }
    return "-";
    }
}